<template>
    <div class="form-group">
        <label :for="id" v-text="label"></label>
        <vue-dropzone
                :id="id"
                ref="dropzone"
                :options="options"
                :destroyDropzone="true"
                @vdropzone-sending="sending"
                @vdropzone-success="uploadedFile"
                @vdropzone-removed-file="removedFile"
                @vdropzone-file-added-manually="addedFileManually">
        </vue-dropzone>
        <file-modal ref="modal" :file="currentFile" :type="type" @saved="$emit('saved')"></file-modal>
    </div>
</template>
<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.css";
import FileModal from "./FileModal";

export default {
  props: ["value", "label", "type", "maxFiles"],
  components: {
    vueDropzone: vue2Dropzone,
    fileModal: FileModal
  },
  data() {
    return {
      files: [],
      currentFile: {},
      options: {
        url:
          window.baseUrl +
          "/api/" +
          store.state.language +
          "/content/create_" +
          this.type +
          "_part",
        thumbnailWidth: 150,
        maxFiles: this.maxFiles ? this.maxFiles : 1,
        paramName: "edit_" + this.type + "_part[file]",
        addRemoveLinks: true,
        dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>Datei hochladen",
        previewTemplate: this.template()
      }
    };
  },
  computed: {
    id() {
      if (this.maxFiles) {
        return "multiple_input_" + Math.random();
      } else {
        return this.value ? "input_" + this.value.id : "input_" + Math.random();
      }
    }
  },
  methods: {
    template() {
      return `<div class="dz-preview dz-file-preview">
                <div class="dz-move"></div>
                <div class="dz-image">
                    <img data-dz-thumbnail>
                </div>
                <div class="dz-details">
                    <div class="dz-filename"><span data-dz-name></span></div>
                </div>
                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                <div class="dz-error-message"><span data-dz-errormessage></span></div>
                <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                <div class="dz-error-mark"><i class="fa fa-close"></i></div>
            </div>
            `;
    },
    uploadedFile(file, response) {
      if (this.maxFiles) {
        this.files.push(response.result);
        this.$emit("input", this.files);
      } else {
        this.$emit("input", response.result);
      }
      $(file.previewElement).data("filedata", response.result);
      $("a.dz-test.dz-remove").click("click", event => event.stopPropagation());
      file.previewElement.addEventListener("click", () => {
        this.$emit("edit");
        this.editFile(response.result);
      });
    },
    removedFile(file, error, xhr) {
      if (this.maxFiles) {
        let fileData = $(file.previewElement).data("filedata");
        this.files.splice(this.files.indexOf(fileData), 1);
      } else {
        this.files = [];
      }
      this.$emit("input", this.files);
    },
    editFile(fileInfo) {
      this.currentFile = fileInfo;
      this.$nextTick(() => {
        this.$refs.modal.show();
      });
    },
    sending(file, xhr, formData) {
      formData.append(
        "edit_" + this.type + "_part[translation_name]",
        file.name
      );
      formData.append(
        "edit_" + this.type + "_part[translation_description]",
        file.name
      );
    },
    addedFileManually(file) {
      $(file.previewElement).data("filedata", file.filedata)

      let self = this;
      file.previewElement.addEventListener("click", function(event) {
        self.editFile($(this).data("filedata"));
      });
    },
    save() {}
  },
  mounted() {
    if (this.value) {
      if (this.maxFiles) {
        for (let img of this.value) {
          this.$refs.dropzone.manuallyAddFile(
            {
              name: img.name,
              filedata: img
            },
            this.type === "image" ? img.urls.preview : false
          );
        }
        this.files = this.value;
      } else {
        this.$refs.dropzone.manuallyAddFile(
          {
            name: this.value.name,
            filedata: this.value
          },
          this.type === "image" ? this.value.urls.preview : false
        );
      }
    }
    $(".vue-dropzone").sortable({
      items: ".dz-preview",
      cursor: "move",
      opacity: 0.5,
      containment: "parent",
      distance: 20,
      tolerance: "pointer",
      update: (e, ui) => {
        let $el = $(ui.item[0]);
        $el.removeAttr("style");
        let imageIds = [];
        $(".dz-preview").each((key, el) => {
          imageIds.push($(el).data("filedata").id);
        });
        store.commit("addSavingProcess");
        axios
          .post(
            "/api/" +
              store.state.language +
              "/content/set_" +
              this.type +
              "_part_order",
            { blocks: imageIds }
          )
          .then(({ data }) => {
            store.commit("finishSavingProcess");
          });
      }
    });
  }
};
</script>
<style>
.dz-move {
  position: absolute;
  top: 5px;
  right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Parts/Input/File.vue